export default {
  title: 'Wdrożenie Wolt Drive',
  subtitle: 'Widoczne tylko dla menedżerów wdrożenia.',
  steps: {
    request: {
      title: '1. Poproś Wolt o lokal',
      description:
        'Kopiuje wiersz tej restauracji do wspólnego arkusza Wolt. Wklej go do kolumny A w pierwszym pustym wierszu, a następnie poinformuj Wolt na wspólnym kanale Slack.',
    },
    activate: {
      title: '2. Zweryfikuj i aktywuj',
      description:
        'Wpisz identyfikator lokalu dodany przez Wolt do arkusza. Jest on sprawdzany testową wyceną od Wolt, zanim cokolwiek zostanie zapisane.',
    },
  },
  fields: {
    venue_id: {
      label: 'Identyfikator lokalu Wolt',
      placeholder: 'np. 6736f9f5f9e2ab82f9150420',
      invalid: 'Identyfikator lokalu Wolt ma 24 znaki i używa tylko 0–9 oraz a–f.',
    },
    priority: {
      label: 'Priorytet dostawcy',
      options: {
        wolt_primary: 'Wolt priorytetowo, obecni dostawcy jako zapasowi',
        wolt_only: 'Tylko Wolt',
      },
    },
  },
  verification: {
    verified: 'Wolt potwierdził ten lokal.',
    failed: 'Wolt nie mógł potwierdzić tego lokalu.',
    wolt_reason: 'Wolt odpowiedział: {{reason}}',
    unavailable_now: 'Wolt nie może teraz dostarczać z tego lokalu ({{reason}}). Mimo to możesz go zapisać.',
  },
  preview: {
    label: 'Kolejność dostawców',
    none: 'brak',
  },
  hints: {
    internal_delivery:
      'Ta restauracja dostarcza własnymi kierowcami. Wolt jest używany, gdy tryb dostawy poniżej jest ustawiony na zewnętrznych kierowców.',
    invalid_stored_id:
      'Zapisany identyfikator lokalu {{venueId}} nie jest prawidłowym identyfikatorem lokalu Wolt, więc Wolt nie jest używany dla tej restauracji. Zweryfikuj i zapisz prawidłowy identyfikator.',
  },
  buttons: {
    copy_details: 'Kopiuj dane',
    verify: 'Zweryfikuj',
    save: 'Zapisz',
  },
  confirm: {
    title: 'Aktywować Wolt Drive?',
    description: 'Zapisuje identyfikator lokalu {{venueId}} i zmienia kolejność dostawców na: {{providers}}.',
    unsaved_providers: 'Niezapisane zmiany na poniższej liście dostawców zostaną zastąpione.',
    ok: 'Zapisz',
    cancel: 'Anuluj',
  },
  toasts: {
    copied: 'Skopiowano',
    copy_failed: 'Nie udało się skopiować danych. Spróbuj ponownie.',
    saved: 'Wolt Drive jest skonfigurowany dla tej restauracji.',
    save_failed: 'Nie udało się zapisać. Spróbuj ponownie.',
  },
};
